var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-data"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({ src: _vm.trueAiOrBigData,
      loading: _vm.aiOrBigData}),expression:"{ src: trueAiOrBigData,\n      loading: aiOrBigData}",arg:"background-image"}],staticClass:"banner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }